import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CtaButton from '../generics/cta-button';
import userStore from "../../store/session-user-store";
import LanguageSwitcher from '../generics/language-switcher';
import { Menu, X } from 'lucide-react';
import toastStore from '../../store/toast-store';

const Header: React.FC = () => {
  const { t, i18n } = useTranslation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  
  // Extraire le préfixe de langue actuel
  const currentLang = i18n.language || 'fr';

  return (
    <header className="fixed top-4 left-1/2 transform -translate-x-1/2 w-[95%] max-w-7xl bg-white/70 backdrop-blur-md z-50 rounded-2xl">
      <div className="px-6 py-4 flex items-center justify-between">
        {/* Logo à gauche */}
        <a href={`${process.env.REACT_APP_HOME_URL}`} className="flex items-center space-x-2">
          <img
            src="/prestaslot-transparent.svg"
            alt="PrestaSlot"
            className="h-10"
          />
        </a>

        {/* Navigation desktop et boutons - cachés sur mobile */}
        <div className="hidden md:flex items-center space-x-8">
          <div className="flex items-center space-x-4">
            <LanguageSwitcher />

            {userStore.isUserAuthenticated ? (
              <CtaButton
                text={t('common.myAccount', 'Mon compte') || ''}
                to={`/${currentLang}/provider/dashboard`}
                variant="primary"
                size="sm"
              />
            ) : (
              <a
                href={`/${currentLang}/login`}
                className="px-5 py-2.5 rounded-full bg-primary/90 text-white hover:bg-primary-dark transition-all duration-300 shadow-md hover:shadow-lg border border-primary/20"
              >
                {t('common.professional', 'Espace Pro')}
              </a>
            )}
          </div>
        </div>

        {/* Mobile menu button */}
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="md:hidden p-2 rounded-lg bg-primary/10 hover:bg-primary/20 text-primary focus:outline-none transition-all duration-300"
          aria-label="Menu"
        >
          {isMobileMenuOpen ? (
            <X className="h-5 w-5" />
          ) : (
            <Menu className="h-5 w-5" />
          )}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white/80 backdrop-blur-md rounded-b-2xl overflow-hidden">
          <nav className="px-6 py-4 flex flex-col space-y-3">
            {/* Language Switcher in mobile menu */}
            <div className="flex justify-center mb-2">
              <LanguageSwitcher />
            </div>

            {/* Boutons de compte dans le menu mobile */}
            <button
              onClick={() => {
                toastStore.addToast('info', t('common.mobileNotAvailable'));
              }}
              className="text-gray-700 hover:text-primary py-2 font-medium transition-all duration-300"
            >
              {t('common.info')}
            </button>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
